import "../../utils/tailwind.css";
import { PageProvider, usePageProvider } from "./provider";
import { Accordion } from "react-bootstrap";
import { Formik, Form, FieldArray } from "formik";
import { FormikInput } from "../../components/input";
import Label from "../../components/label";
import ImageUploader from "../../components/upload-image";
import Button from "../../components/Buttons";
import { FormikTextarea } from "../../components/textarea";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export default function IndustrialPage() {
  return (
    <div className="p-0">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, handleSubmit } = usePageProvider();

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
      {({ values, setFieldValue }) => (
        <Form>
          <Accordion defaultActiveKey="0" className="my-4">
            {/* SEO SECTION */}
            <Accordion.Item eventKey="0" className="w-full">
              <Accordion.Header>SEO META</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                  <div className="flex flex-col">
                    <Label label="Meta Title" className="mb-1 " />
                    <FormikInput name="meta_seo.meta_title" placeholder="Meta Title" rootClassName="w-full" />
                  </div>
                  <div className="flex flex-col">
                    <Label label="Meta Keywords" className="mb-1 " />
                    <FormikInput name="meta_seo.meta_keyword" placeholder="Meta Keywords" rootClassName="w-full" />
                  </div>
                  <div className="flex flex-col">
                    <Label label="Meta Slug Url" className="mb-1 " />
                    <FormikInput name="meta_seo.meta_slug_url" placeholder="Meta Slug Url" rootClassName="w-full" />
                  </div>
                  <div className="flex flex-col col-span-3 ">
                    <Label label="Meta Description" className="mb-1 " />
                    <FormikInput name="meta_seo.meta_desc" placeholder="Meta Description" rootClassName="w-full" as="textarea" />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1" className="w-full">
              <Accordion.Header>Banner Section</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6 pb-6 border-b border-gray-100">
                  <div>
                    <Label label="Heading (White)" className="mb-1 " />
                    <FormikInput name="banner.heading.white" placeholder="Heading (White)" />
                  </div>
                  <div>
                    <Label label="Heading (Orange)" className="mb-1 " />
                    <FormikInput name="banner.heading.orange" placeholder="Heading (Orange)" />
                  </div>
                  <div>
                    <Label label="Sub Heading" className="mb-1 " />
                    <FormikInput name="banner.subHeading" placeholder="Sub Heading" />
                  </div>
                  <div>
                    <Label label="Cta Title" className="mb-1 " />
                    <FormikInput name="banner.cta_title" placeholder="Cta Title" />
                  </div>
                  <div>
                    <Label label="Cta Download" className="mb-1 " />
                    <ImageUploader className="text-xs" imgStyle={{ fontSize: "12px" }}
                      title="Asset"
                      imageUrl={values.banner?.cta_download}
                      onChange={(res) => setFieldValue("banner.cta_download", res?.data?.file_url)}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  <div>
                    <Label label="Banner Context Paragraphs" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                    <FieldArray name="banner.paragraphs">
                      {(arrayHelpers) => (
                        <div className="overflow-x-auto">
                          <table className="w-full border border-gray-200 rounded-lg overflow-hidden bg-white">
                            <thead className="bg-gray-50 border-b">
                              <tr>
                                <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Paragraph Content</th>
                                <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-16">Action</th>
                              </tr>
                            </thead>
                            <tbody className="divide-y">
                              {values.banner?.paragraphs?.map((p, index) => (
                                <tr key={index} className="hover:bg-gray-50/50">
                                  <td className="p-2 border-r">
                                    <FormikTextarea name={`banner.paragraphs.${index}`} rootClassName="w-full" className="text-sm !h-20" />
                                  </td>
                                  <td className="p-2 text-center align-middle">
                                    <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-600">
                                      <FontAwesomeIcon icon={faTrash} size="sm" />
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <div className="mt-3">
                            <Button type="button" variant="outline" className="!py-1 !px-4 !text-[11px]" onClick={() => arrayHelpers.push("")}>
                              + Add Paragraph
                            </Button>
                          </div>
                        </div>
                      )}
                    </FieldArray>
                  </div>
                  <div>
                    <Label label="Banner Background Image" className="mb-2 text-black font-semibold" />
                    <ImageUploader
                      imageUrl={values.banner?.image}
                      onChange={(res) => setFieldValue("banner.image", res?.data?.file_url)}
                      imgStyle={{ width: "100%", height: "180px" }}
                    />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2" className="w-full">
              <Accordion.Header>Detailed Specifications Section</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mb-3">
                  <div>
                    <Label label="Title" className="mb-1" />
                    <FormikInput name="detail.title" placeholder="Title" />
                  </div>
                  <div>
                    <Label label="Description" className="mb-1" />
                    <FormikInput name="detail.desc" placeholder="Description" />
                  </div>
                  <div>
                    <Label label="Heading (Black)" className="mb-1" />
                    <FormikInput name="detail.heading.black" placeholder="Heading (Black)" />
                  </div>
                  <div>
                    <Label label="Heading (Orange)" className="mb-1" />
                    <FormikInput name="detail.heading.orange" placeholder="Heading (Orange)" />
                  </div>
                  <div >
                    <Label label="Sub Heading / Highlight" className="mb-1" />
                    <FormikInput name="detail.sub_heading" placeholder="Sub Heading" />
                  </div>
                </div>

                <div className="mb-8">
                  <Label label="Key Description Paragraphs" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                  <FieldArray name="detail.paragraphs">
                    {(arrayHelpers) => (
                      <div className="overflow-x-auto">
                        <table className="w-full border border-gray-200 rounded-lg overflow-hidden bg-white">
                          <thead className="bg-gray-50 border-b">
                            <tr>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Detailed Text Content</th>
                              <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-16">Action</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y">
                            {values.detail?.paragraphs?.map((p, index) => (
                              <tr key={index} className="hover:bg-gray-50/50">
                                <td className="p-2 border-r">
                                  <FormikTextarea name={`detail.paragraphs.${index}`} rootClassName="w-full" className="text-sm !h-24" />
                                </td>
                                <td className="p-2 text-center align-middle">
                                  <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-600">
                                    <FontAwesomeIcon icon={faTrash} size="sm" />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="mt-3">
                          <Button type="button" variant="outline" className="!py-1 !px-4 !text-[11px]" onClick={() => arrayHelpers.push("")}>
                            + Add Description Layer
                          </Button>
                        </div>
                      </div>
                    )}
                  </FieldArray>
                </div>

                <Label label="Detailed Highlight Blocks" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs pt-4 border-t" />
                <FieldArray name="detail.sections">
                  {(arrayHelpers) => (
                    <div className="space-y-6">
                      {values.detail?.sections?.map((section, sIndex) => (
                        <div key={sIndex} className="border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                          <div className="bg-gray-50 px-4 py-2 border-b flex justify-between items-center">
                            <span className="font-bold text-[12px] text-[#1e1e5c] uppercase">Detail Block #{sIndex + 1}</span>
                            <button type="button" onClick={() => arrayHelpers.remove(sIndex)} className="text-red-400 hover:text-red-600">
                              <FontAwesomeIcon icon={faTrash} />
                            </button>
                          </div>
                          <div className="p-4 bg-white">
                            <div className="mb-4">
                              <Label label="Block Title" className="mb-1" />
                              <FormikInput name={`detail.sections.${sIndex}.title`} placeholder="Section Title" />
                            </div>

                            <Label label="Feature Points" className="mb-2 font-black text-[10px] uppercase text-gray-400" />
                            <FieldArray name={`detail.sections.${sIndex}.points`}>
                              {(pHelpers) => (
                                <div className="overflow-x-auto">
                                  <table className="w-full border border-gray-200 rounded-lg overflow-hidden bg-gray-50/30">
                                    <thead className="bg-gray-100">
                                      <tr>
                                        <th className="p-2 text-left text-[10px] font-black uppercase text-gray-500">Label Text</th>
                                        <th className="p-2 text-left text-[10px] font-black uppercase text-gray-500 w-32">Icon Image</th>
                                        <th className="p-2 text-center text-[10px] font-black uppercase text-gray-500 w-12"></th>
                                      </tr>
                                    </thead>
                                    <tbody className="divide-y bg-white">
                                      {section.points?.map((point, pIndex) => (
                                        <tr key={pIndex}>
                                          <td className="p-1 border-r">
                                            <FormikInput name={`detail.sections.${sIndex}.points.${pIndex}.text`} placeholder="Point Text" className="text-sm !h-9" />
                                          </td>
                                          <td className="p-1 border-r">
                                            <ImageUploader
                                              imgStyle={{ width: "35px", height: "35px" }}
                                              imageUrl={point.logo_img}
                                              onChange={(res) => setFieldValue(`detail.sections.${sIndex}.points.${pIndex}.logo_img`, res?.data?.file_url)}
                                            />
                                          </td>
                                          <td className="p-1 text-center">
                                            <button type="button" onClick={() => pHelpers.remove(pIndex)} className="text-red-300 hover:text-red-500">
                                              <FontAwesomeIcon icon={faTrash} size="sm" />
                                            </button>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                  <div className="mt-2">
                                    <Button type="button" variant="outline" className="!py-1 !px-3 !text-[10px]" onClick={() => pHelpers.push({ text: "", logo_img: "" })}>
                                      + Add Point
                                    </Button>
                                  </div>
                                </div>
                              )}
                            </FieldArray>
                          </div>
                        </div>
                      ))}
                      <div className="mt-4">
                        <Button type="button" variant="outline" className="!py-2 !px-6" onClick={() => arrayHelpers.push({ title: "", points: [] })}>
                          + Add New Detail Block
                        </Button>
                      </div>
                    </div>
                  )}
                </FieldArray>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10 pt-6 border-t border-gray-100">
                  <div>
                    <Label label="Primary Detail Image" className="mb-2 " />
                    <ImageUploader
                      imageUrl={values.detail?.image?.url}
                      onChange={(res) => setFieldValue("detail.image.url", res?.data?.file_url)}
                      imgStyle={{ width: "100%", height: "250px" }}
                    />
                  </div>
                  <div className="flex flex-col justify-center">
                    <Label label="Image SEO Alt Tag" className="mb-1" />
                    <FormikInput name="detail.image.alt" placeholder="Image Alt Text" />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* DISTANCE SECTION */}
            <Accordion.Item eventKey="3" className="w-full">
              <Accordion.Header>Distance & Connectivity</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 gap-6">
                  <div>
                    <Label label="Section Main Heading" className="mb-1 " />
                    <FormikInput name="distance.title" placeholder="Explore connectivity..." />
                  </div>

                  <Label label="Distance Connectivity Map" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                  <FieldArray name="distance.cards">
                    {(arrayHelpers) => (
                      <div className="overflow-x-auto">
                        <table className="w-full border border-gray-200 rounded-lg overflow-hidden bg-white">
                          <thead className="bg-gray-50 border-b">
                            <tr>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Destination / City</th>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Distance (KM/Mins)</th>
                              <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-16">Action</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y">
                            {values.distance?.cards?.map((card, index) => (
                              <tr key={index} className="hover:bg-gray-50/50">
                                <td className="p-2 border-r">
                                  <FormikInput name={`distance.cards.${index}.city`} placeholder="City Name" className="text-sm font-semibold" />
                                </td>
                                <td className="p-2 border-r">
                                  <FormikInput name={`distance.cards.${index}.distance`} placeholder="e.g. 10 KM" className="text-sm" />
                                </td>
                                <td className="p-2 text-center">
                                  <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-600">
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="mt-4">
                          <Button type="button" variant="outline" className="!py-2 !px-4 !text-[12px]" onClick={() => arrayHelpers.push({ city: "", distance: "" })}>
                            + Add New Destination
                          </Button>
                        </div>
                      </div>
                    )}
                  </FieldArray>

                  <div>
                    <Label label="Bottom Context Description" className="mb-1 " />
                    <FormikTextarea name="distance.bottom_para" placeholder="Deep dive into location advantages..." />
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* LOCATION SLIDER */}
            <Accordion.Item eventKey="4" className="w-full">
              <Accordion.Header>Why This Location? (Slider)</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 gap-6">
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    <div>
                      <Label label="Heading (Black)" className="mb-1 " />
                      <FormikInput name="locationSlider.heading.black" placeholder="Heading (Black)" />
                    </div>
                    <div>
                      <Label label="Heading (Orange)" className="mb-1 " />
                      <FormikInput name="locationSlider.heading.orange" placeholder="Heading (Orange)" />
                    </div>
                    <div>
                      <Label label="Sub Heading" className="mb-1 " />
                      <FormikInput name="locationSlider.sub_heading" placeholder="Sub Heading" />
                    </div>
                  </div>

                  <Label label="Location Feature Slides" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs pt-4 border-t" />
                  <FieldArray name="locationSlider.slides">
                    {(arrayHelpers) => (
                      <div className="overflow-x-auto">
                        <table className="w-full border border-gray-200 rounded-lg overflow-hidden bg-white">
                          <thead className="bg-gray-50 border-b">
                            <tr>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500 w-1/4">Slide Data</th>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Full Description</th>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500 w-40">Slide Image</th>
                              <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-12"></th>
                            </tr>
                          </thead>
                          <tbody className="divide-y">
                            {values.locationSlider?.slides?.map((slide, index) => (
                              <tr key={index} className="hover:bg-gray-50/50">
                                <td className="p-2 border-r align-top">
                                  <div className="space-y-2">
                                    <Label label="Slide Title" className="mb-0 text-[11px] text-gray-400" />
                                    <FormikInput name={`locationSlider.slides.${index}.title`} placeholder="Title" className="text-sm font-semibold" />
                                  </div>
                                </td>
                                <td className="p-2 border-r align-top">
                                  <FormikTextarea name={`locationSlider.slides.${index}.description`} placeholder="Description" className="text-sm !h-24" />
                                </td>
                                <td className="p-2 border-r align-middle">
                                  <ImageUploader
                                    imgStyle={{ width: "100%", height: "80px" }}
                                    imageUrl={slide.image}
                                    onChange={(res) => setFieldValue(`locationSlider.slides.${index}.image`, res?.data?.file_url)}
                                  />
                                </td>
                                <td className="p-2 text-center align-middle">
                                  <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-700">
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="mt-4">
                          <Button type="button" variant="outline" className="!py-2 !px-4 !text-[12px]" onClick={() => arrayHelpers.push({ image: "", title: "", description: "" })}>
                            + Add Location Slide
                          </Button>
                        </div>
                      </div>
                    )}
                  </FieldArray>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* BUSINESS SLIDER */}
            <Accordion.Item eventKey="5" className="w-full">
              <Accordion.Header>Industrial Ecosystem Slider</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 gap-6">
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pb-6 border-b">
                    <div>
                      <Label label="Header (White)" className="mb-1 " />
                      <FormikInput name="sliderSection.heading.white" placeholder="Heading (White)" />
                    </div>
                    <div>
                      <Label label="Header (Orange)" className="mb-1 " />
                      <FormikInput name="sliderSection.heading.orange" placeholder="Heading (Orange)" />
                    </div>
                    <div>
                      <Label label="Sub Heading" className="mb-1 " />
                      <FormikInput name="sliderSection.subHeading" placeholder="Sub Heading" />
                    </div>
                    <div className="sm:col-span-3">
                      <Label label="Main Ecosystem Description" className="mb-1 " />
                      <FormikTextarea name="sliderSection.description" placeholder="Description" />
                    </div>
                  </div>

                  <Label label="Ecosystem Capability Cards" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                  <FieldArray name="sliderSection.cards">
                    {(arrayHelpers) => (
                      <div className="overflow-x-auto">
                        <table className="w-full border border-gray-200 rounded-lg overflow-hidden bg-white">
                          <thead className="bg-gray-50 border-b">
                            <tr>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500 w-1/4">Card Title</th>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Summary</th>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500 w-32">Visual</th>
                              <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-12"></th>
                            </tr>
                          </thead>
                          <tbody className="divide-y">
                            {values.sliderSection?.cards?.map((card, index) => (
                              <tr key={index} className="hover:bg-gray-50/50">
                                <td className="p-2 border-r align-top">
                                  <FormikInput name={`sliderSection.cards.${index}.title`} placeholder="Title" className="text-sm font-semibold" />
                                </td>
                                <td className="p-2 border-r align-top">
                                  <FormikTextarea name={`sliderSection.cards.${index}.desc`} placeholder="Description" className="text-sm !h-20" />
                                </td>
                                <td className="p-2 border-r align-middle">
                                  <ImageUploader
                                    imgStyle={{ width: "60px", height: "45px" }}
                                    imageUrl={card.img}
                                    onChange={(res) => setFieldValue(`sliderSection.cards.${index}.img`, res?.data?.file_url)}
                                  />
                                </td>
                                <td className="p-2 text-center align-middle">
                                  <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-700 transition-colors">
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="mt-4">
                          <Button type="button" variant="outline" className="!py-2 !px-6 !text-[12px]" onClick={() => arrayHelpers.push({ title: "", desc: "", img: "" })}>
                            + Add Ecosystem Card
                          </Button>
                        </div>
                      </div>
                    )}
                  </FieldArray>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* USE CASES */}
            <Accordion.Item eventKey="6" className="w-full">
              <Accordion.Header>Versatile Use Cases</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 gap-6">
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pb-4">
                    <div>
                      <Label label="Top Level Title" className="mb-1 " />
                      <FormikInput name="useCases.heading.title" placeholder="Title" />
                    </div>
                    <div>
                      <Label label="Section Highlight" className="mb-1 " />
                      <FormikInput name="useCases.heading.highlight" placeholder="Highlight" />
                    </div>
                    <div>
                      <Label label="Internal Subtitle" className="mb-1 " />
                      <FormikInput name="useCases.heading.subtitle" placeholder="Subtitle" />
                    </div>
                  </div>

                  <Label label="Use Case Configuration" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs pt-4 border-t" />
                  <FieldArray name="useCases.items">
                    {(arrayHelpers) => (
                      <div className="overflow-x-auto">
                        <table className="w-full border border-gray-200 rounded-lg overflow-hidden bg-white">
                          <thead className="bg-gray-50 border-b">
                            <tr>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500 w-1/4">Case Title</th>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Case Description</th>
                              <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500 w-32">Icon Image</th>
                              <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-12"></th>
                            </tr>
                          </thead>
                          <tbody className="divide-y">
                            {values.useCases?.items?.map((item, index) => (
                              <tr key={index} className="hover:bg-gray-50/50 transition-colors">
                                <td className="p-2 border-r align-top">
                                  <FormikInput name={`useCases.items.${index}.title`} placeholder="Title" className="text-sm font-semibold" />
                                </td>
                                <td className="p-2 border-r align-top">
                                  <FormikTextarea name={`useCases.items.${index}.desc`} placeholder="Description" className="text-sm !h-20" />
                                </td>
                                <td className="p-2 border-r align-middle">
                                  <ImageUploader
                                    imgStyle={{ width: "45px", height: "45px" }}
                                    imageUrl={item.icon_img}
                                    onChange={(res) => setFieldValue(`useCases.items.${index}.icon_img`, res?.data?.file_url)}
                                  />
                                </td>
                                <td className="p-2 text-center align-middle">
                                  <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-700 transition-colors">
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="mt-4">
                          <Button type="button" variant="outline" className="!py-2 !px-6 !text-[12px]" onClick={() => arrayHelpers.push({ title: "", desc: "", icon_img: "" })}>
                            + Add Use Case Item
                          </Button>
                        </div>
                      </div>
                    )}
                  </FieldArray>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* OFFERING SECTION */}
            <Accordion.Item eventKey="7" className="w-full">
              <Accordion.Header>Our Core Offering</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
                  <div>
                    <Label label="Offer Title" className="mb-1 " />
                    <FormikInput name="offering.title" placeholder="Title" />
                  </div>
                  <div>
                    <Label label="Offer Highlight" className="mb-1 " />
                    <FormikInput name="offering.highlight" placeholder="Highlight" />
                  </div>
                  <div>
                    <Label label="Offer Subtitle" className="mb-1 " />
                    <FormikInput name="offering.subtitle" placeholder="Subtitle" />
                  </div>
                  <div className="sm:col-span-3">
                    <Label label="Full Detailed Offering Description" className="mb-1 " />
                    <FormikTextarea name="offering.desc" placeholder="Offer Description" />
                  </div>
                </div>
                <div className="pt-6 border-t">
                  <Label label="Promotional Offering Image" className="mb-2 " />
                  <ImageUploader
                    imageUrl={values.offering?.image}
                    onChange={(res) => setFieldValue("offering.image", res?.data?.file_url)}
                    imgStyle={{ width: "100%", height: "280px" }}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* INFRASTRUCTURE & SAFETY */}
            <Accordion.Item eventKey="8" className="w-full">
              <Accordion.Header>Industrial Infrastructure & Safety</Accordion.Header>
              <Accordion.Body>
                <div className="space-y-12">
                  {/* Infrastructure Sub-Section */}
                  <div className="border border-gray-100 rounded-3xl p-6 bg-gray-50/20 shadow-sm relative overflow-hidden">
                    <div className="absolute top-0 right-0 p-4 bg-indigo-50 rounded-bl-3xl text-indigo-700 font-black text-[10px] uppercase tracking-widest">Infra Layer</div>
                    <h5 className="font-black text-xl mb-6 text-[#1e1e5c] border-b pb-2 flex items-center gap-2">
                      Core Infrastructure
                    </h5>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
                      <div className="space-y-4">
                        <div>
                          <Label label="Layer Title" className="mb-1" />
                          <FormikInput name="infrastructure.infrastructure.title" placeholder="Infrastructure" />
                        </div>
                        <div>
                          <Label label="Highlight / Emphasis" className="mb-1" />
                          <FormikInput name="infrastructure.infrastructure.highlight" placeholder="Elite Facilities" />
                        </div>
                        <div>
                          <Label label="Sub-caption" className="mb-1" />
                          <FormikInput name="infrastructure.infrastructure.subtitle" placeholder="Subtitle" />
                        </div>
                        <div>
                          <Label label="Section Footer Note" className="mb-1" />
                          <FormikInput name="infrastructure.infrastructure.note" placeholder="Footer Note" />
                        </div>
                      </div>
                      <div className="flex flex-col justify-end">
                        <Label label="Supporting Visual" className="mb-2" />
                        <ImageUploader
                          imageUrl={values.infrastructure?.infrastructure?.image}
                          onChange={(res) => setFieldValue("infrastructure.infrastructure.image", res?.data?.file_url)}
                          imgStyle={{ width: "100%", height: "180px" }}
                        />
                      </div>
                    </div>

                    <Label label="Infrastructure Specification Points" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                    <FieldArray name="infrastructure.infrastructure.points">
                      {(arrayHelpers) => (
                        <div className="overflow-x-auto">
                          <table className="w-full border border-gray-200 rounded-lg overflow-hidden bg-white">
                            <thead className="bg-gray-50 border-b">
                              <tr>
                                <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Specification Label</th>
                                <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500 w-40">Detail Icon</th>
                                <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-16">Action</th>
                              </tr>
                            </thead>
                            <tbody className="divide-y">
                              {values.infrastructure?.infrastructure?.points?.map((p, index) => (
                                <tr key={index} className="hover:bg-gray-50/50">
                                  <td className="p-2 border-r">
                                    <FormikInput name={`infrastructure.infrastructure.points.${index}.text`} placeholder="24/7 Power..." className="text-sm" />
                                  </td>
                                  <td className="p-2 border-r align-middle">
                                    <ImageUploader
                                      imgStyle={{ width: "40px", height: "40px" }}
                                      imageUrl={p.icon_img}
                                      onChange={(res) => setFieldValue(`infrastructure.infrastructure.points.${index}.icon_img`, res?.data?.file_url)}
                                    />
                                  </td>
                                  <td className="p-2 text-center align-middle">
                                    <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-600 transition-colors">
                                      <FontAwesomeIcon icon={faTrash} size="sm" />
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <div className="mt-4">
                            <Button type="button" variant="outline" className="!py-2 !px-4 !text-[11px]" onClick={() => arrayHelpers.push({ text: "", icon_img: "" })}>
                              + Add Infra Specification
                            </Button>
                          </div>
                        </div>
                      )}
                    </FieldArray>
                  </div>

                  {/* Safety Sub-Section */}
                  <div className="border border-gray-100 rounded-3xl p-6 bg-gray-50/20 shadow-sm relative overflow-hidden">
                    <div className="absolute top-0 right-0 p-4 bg-orange-50 rounded-bl-3xl text-orange-700 font-black text-[10px] uppercase tracking-widest">Safety Layer</div>
                    <h5 className="font-black text-xl mb-6 text-[#1e1e5c] border-b pb-2 flex items-center gap-2">
                      Security & Protocols
                    </h5>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
                      <div className="space-y-4">
                        <div>
                          <Label label="Safety Heading" className="mb-1" />
                          <FormikInput name="infrastructure.safety.title" placeholder="Security & Safety" />
                        </div>
                        <div>
                          <Label label="Layer Highlight" className="mb-1" />
                          <FormikInput name="infrastructure.safety.highlight" placeholder="Uncompromised Safety" />
                        </div>
                        <div>
                          <Label label="Brief Caption" className="mb-1" />
                          <FormikInput name="infrastructure.safety.subtitle" placeholder="Subtitle" />
                        </div>
                      </div>
                      <div className="flex flex-col justify-end">
                        <Label label="Safety Visualization" className="mb-2" />
                        <ImageUploader
                          imageUrl={values.infrastructure?.safety?.image}
                          onChange={(res) => setFieldValue("infrastructure.safety.image", res?.data?.file_url)}
                          imgStyle={{ width: "100%", height: "180px" }}
                        />
                      </div>
                    </div>

                    <Label label="Global Safety Protocols" className="mb-3 font-bold text-[#1e1e5c] uppercase text-xs" />
                    <FieldArray name="infrastructure.safety.points">
                      {(arrayHelpers) => (
                        <div className="overflow-x-auto">
                          <table className="w-full border border-gray-200 rounded-lg overflow-hidden bg-white">
                            <thead className="bg-gray-50 border-b">
                              <tr>
                                <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500">Security Measure</th>
                                <th className="p-2 text-left text-[11px] font-black uppercase text-gray-500 w-40">Protocol Icon</th>
                                <th className="p-2 text-center text-[11px] font-black uppercase text-gray-500 w-16">Action</th>
                              </tr>
                            </thead>
                            <tbody className="divide-y">
                              {values.infrastructure?.safety?.points?.map((p, index) => (
                                <tr key={index} className="hover:bg-gray-50/50">
                                  <td className="p-2 border-r">
                                    <FormikInput name={`infrastructure.safety.points.${index}.text`} placeholder="Fire suppression..." className="text-sm" />
                                  </td>
                                  <td className="p-2 border-r align-middle">
                                    <ImageUploader
                                      imgStyle={{ width: "40px", height: "40px" }}
                                      imageUrl={p.icon_img}
                                      onChange={(res) => setFieldValue(`infrastructure.safety.points.${index}.icon_img`, res?.data?.file_url)}
                                    />
                                  </td>
                                  <td className="p-2 text-center align-middle">
                                    <button type="button" onClick={() => arrayHelpers.remove(index)} className="text-red-400 hover:text-red-600 transition-colors">
                                      <FontAwesomeIcon icon={faTrash} size="sm" />
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <div className="mt-4">
                            <Button type="button" variant="outline" className="!py-2 !px-4 !text-[11px]" onClick={() => arrayHelpers.push({ text: "", icon_img: "" })}>
                              + Add Safety Measure
                            </Button>
                          </div>
                        </div>
                      )}
                    </FieldArray>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="9" className="w-full">
              <Accordion.Header>{"Footer Banner Image"}</Accordion.Header>
              <Accordion.Body>
                <div className="grid grid-cols-1 mb-6">
                  <Label label="Footer Banner Image" className="mb-1" />
                  <ImageUploader className="text-xs" imgStyle={{ fontSize: "12px" }}
                    title="Footer Banner Image"
                    imageUrl={values.footer_bgimg}
                    onChange={(res) => setFieldValue("footer_bgimg", res?.data?.file_url)}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          {/* FIXED BOTTOM SAVE BAR */}
          <div className="save-button-bar !bg-white/95 !backdrop-blur-md">
            <Button
              type="submit"
              label="SAVE CHANGES"
            />
          </div>
        </Form>
      )}
    </Formik>
  );
}
